
// COMPONENT ///////////////////////////////////////////////////////////////////
export default {
  name: 'MyNumberCardPrepaidAccountBalance',

  data() {
    return {
      icons: {
        ballance: require("@/assets/wallet.svg"),
      }
    }
  },

  props: {
    accountBalance: {
      type: String,
      required: true,
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/MyAccount/MyNumberCard/MyNumberCardPrepaidAccountBalance/component.js